import { render, staticRenderFns } from "./WidgetAdvert.vue?vue&type=template&id=63bfa688&scoped=true"
import script from "./WidgetAdvert.vue?vue&type=script&lang=js"
export * from "./WidgetAdvert.vue?vue&type=script&lang=js"
import style0 from "./WidgetAdvert.vue?vue&type=style&index=0&id=63bfa688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bfa688",
  null
  
)

export default component.exports